export const createInitialConfig = () => ({
    common: {
        enableUsingDefaultUserProfile: false,
    },
    groupChannel: {
        channel: {
            enableMention: false,
            enableOgtag: true,
            enableReactions: true,
            enableReactionsSupergroup: false,
            enableTypingIndicator: true,
            enableVoiceMessage: false,
            input: {
                camera: {
                    enablePhoto: true,
                    enableVideo: true,
                },
                enableDocument: true,
                gallery: {
                    enablePhoto: true,
                    enableVideo: true,
                },
            },
            replyType: 'quote_reply',
            threadReplySelectType: 'thread',
            typingIndicatorTypes: new Set(['text']),
            enableFeedback: false,
            enableSuggestedReplies: false,
            showSuggestedRepliesFor: 'last_message_only',
            suggestedRepliesDirection: 'vertical',
            enableMarkdownForUserMessage: false,
        },
        channelList: {
            enableMessageReceiptStatus: false,
            enableTypingIndicator: false,
        },
        setting: {
            enableMessageSearch: false,
        },
    },
    openChannel: {
        channel: {
            enableOgtag: true,
            input: {
                camera: {
                    enablePhoto: true,
                    enableVideo: true,
                },
                enableDocument: true,
                gallery: {
                    enablePhoto: true,
                    enableVideo: true,
                },
            },
        },
    },
});
function deleteLocalConfigs(config) {
    // @ts-ignore
    delete config.groupChannel.channel.typingIndicatorTypes;
    // @ts-ignore
    delete config.groupChannel.channel.enableFeedback;
    // @ts-ignore
    delete config.groupChannel.channel.enableSuggestedReplies;
    // @ts-ignore
    delete config.groupChannel.channel.showSuggestedRepliesFor;
    // @ts-ignore
    delete config.groupChannel.channel.suggestedRepliesDirection;
    // @ts-ignore
    delete config.groupChannel.channel.enableMarkdownForUserMessage;
    return config;
}
export const createInitialRemoteConfig = () => {
    const config = createInitialConfig();
    return deleteLocalConfigs(config);
};
export const initialConfig = createInitialConfig();
export const initialRemoteConfig = createInitialRemoteConfig();
